module.exports = __webpack_public_path__ + "images/9c672fb6f71c9d4e113419cd073b9167.svg";